import React from 'react';
import {Datagrid, DateField, List, TextField} from 'react-admin';
import {FilmOnVodUrlField} from "../components/my-url-field";

export const PeopleList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="_id" />
            <TextField source="fullname" />
            <FilmOnVodUrlField source="slug" urlFactory={(item) => `https://www.filmon.com/people/${item.slug}`} />

            <DateField source="createdAt"/>
            <DateField source="updatedAt"/>
        </Datagrid>
    </List>
);
